import React, { useState } from 'react';
import styles from './MeControlWrapper.scss';
import { LazyMeControl } from '../index';
import { ME_CONTROL_FALLBACK_ID } from '../utils/constants';
import { type PersonaSize } from 'owa-persona';
import { UserPersonaControl } from 'mini-user-persona';

/**
 * Wrapper component to load MeControl
 */
export const MeControlWrapper = () => {
    const [isMeControlLoaded, setIsMeControlLoaded] = useState<boolean>(false);

    return (
        <>
            {!isMeControlLoaded && (
                <div id={ME_CONTROL_FALLBACK_ID}>
                    <UserPersonaControl
                        className={styles.meControlFallback}
                        size={1}
                        onClickPersona={null}
                        initialsCoinClassName={styles.meControlFallbackInitials}
                        // Since me control default persona does not have image we will block it in the fallback component
                        imageUrl={''}
                    />
                </div>
            )}
            <LazyMeControl onMeControlLoaded={setIsMeControlLoaded} />
        </>
    );
};
